module.exports = __webpack_public_path__ + "media/images/games/35gender/gardening-a87e403dc75c6125e8fbc9113af3810b.png";